import AWS from 'aws-sdk'
import { IdentityPoolId } from '../config'

const fetchUnauthCredentials = (credentials) => {
    return new Promise( (resolve, reject) => {
        if(!credentials) {

            let credentials = new AWS.CognitoIdentityCredentials({
                IdentityPoolId
            })

            credentials.refresh((err) => {
                if(err) reject(err);
                else resolve(credentials);
            })

        }
        else {
            resolve(credentials);
        }
    })
}
const fetchTexts = (credentials, TableName, language) => {
    return new Promise( (resolve, reject) => {

        fetchUnauthCredentials(credentials).then( credentials => {

            // const cloudformation = new AWS.CloudFormation({ credentials })

            // cloudformation.describeStackResource({
            //     LogicalResourceId: 'Texts',
            //     StackName: 'kozy-back-dev'
            // }, (err, res) => {
            //     console.log(err, res);

                const dynamo = new AWS.DynamoDB.DocumentClient({credentials})
                dynamo.query({
                    TableName,
                    KeyConditionExpression: 'Lang = :hkey',
                    ExpressionAttributeValues: {
                        ':hkey': language
                    }
                }, (err, res) => {
                    if(err) reject(err);
                    else resolve(res);
                })
            })


//         })

    })
}

const updateText = (credentials, TableName, textEntity) => {
    return new Promise( (resolve, reject) => {

        fetchUnauthCredentials(credentials).then( credentials => {

            const dynamo = new AWS.DynamoDB.DocumentClient({credentials})
            dynamo.put({
                TableName,
                Item: textEntity
            }, (err, res) => {
                if(err) reject(err);
                else resolve(res);
            })
        })

    })
}

export {
    fetchTexts,
    updateText
}



// WEBPACK FOOTER //
// ./src/api/texts.js